<div class="bg-white rounded-xl border border-slate-200 p-4 flex flex-col gap-3 hover:shadow-md transition-shadow duration-150 h-full">
  <div class="flex items-start gap-3">
    <div class="rounded-lg p-3 flex items-center justify-center" [class]="colorSelected.bgIcon">
      <i [class]="colorSelected.icon"></i>
    </div>
    <div>
      <div class="font-semibold text-gray-800 text-base">{{ categoria().nombre }}</div>
      <div class="text-gray-500 text-sm">{{ categoria().detalle }}</div>
    </div>
  </div>
  <div class="text-gray-500 text-sm">{{ categoria().descripcion }}</div>
  <div class="flex gap-2 mt-auto">
    <button
      class="flex-1 flex items-center justify-center gap-2 bg-accent-50 hover:bg-accent-100 text-accent-700 font-semibold py-2.5 rounded-lg transition active:scale-[0.98] text-xs sm:text-sm"
      (click)="modal_editar_categoria.set(true)"
    >
      <i class="bi bi-pencil"></i> Editar
    </button>
    <button
      class="flex items-center gap-1 bg-red-50 text-red-600 px-4 py-2 rounded transition hover:bg-red-100 border-none"
      (click)="modal_confirmar_eliminar.set(true)"
    >
      <i class="bi bi-trash"></i>
    </button>
  </div>
</div>
<app-dialog
  header="Editar Categoria"
  [modal]="true"
  [(visible)]="modal_editar_categoria"
  (onHide)="modal_editar_categoria.set(false)"
  size="md"
>
  @if(modal_editar_categoria()) {
  <app-editar-categoria [categoria]="categoria()" (cerrar)="closeEditarCategoria($event)" />
  }
</app-dialog>
<app-dialog
  header="Eliminar Categoria"
  [modal]="true"
  [(visible)]="modal_confirmar_eliminar"
  (onHide)="modal_confirmar_eliminar.set(false)"
  size="xs"
>
  <app-modal-confirmacion
    [mensaje]="
      '¿Estás seguro de que deseas eliminar ' +
      categoria().nombre +
      '? \nEsta acción no se puede deshacer.'
    "
    [textoConfirm]="'Sí'"
    [textoCancel]="'No'"
    (confirmar)="eliminarCategoria()"
    (cancelar)="modal_confirmar_eliminar.set(false)"
  />
</app-dialog>
